var _circle, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShowstage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "svg-primary",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 14.4,
    stroke: "url(#paint0_linear_1_5215)",
    strokeWidth: 3.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.2067 14.4739C24.5101 14.7062 23.7649 14.832 22.9902 14.832C19.1242 14.832 15.9902 11.698 15.9902 7.83203C15.9902 7.43491 16.0233 7.04551 16.0868 6.66644C16.0571 6.66616 16.0272 6.66602 15.9974 6.66602C10.8427 6.66602 6.66406 10.8447 6.66406 15.9994C6.66406 21.154 10.8427 25.3327 15.9974 25.3327C21.1521 25.3327 25.3307 21.154 25.3307 15.9994C25.3307 15.4799 25.2883 14.9703 25.2067 14.4739Z",
    fill: "url(#paint1_linear_1_5215)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_5215",
    x1: 16,
    y1: 0,
    x2: 16,
    y2: 32,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#04C9B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#575DF0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1_5215",
    x1: 15.9974,
    y1: 6.66602,
    x2: 15.9974,
    y2: 25.3327,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#19AFD0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#575DF0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShowstage);
export default __webpack_public_path__ + "static/media/showstage.f4d8c53e859b10ca280e93b29bedaf81.svg";
export { ForwardRef as ReactComponent };